<template>
  <span v-if="false" />
</template>

<script lang="ts" setup>
const { initChangeDetection } = useChangeDetection()

void initChangeDetection()
</script>
